module.exports = __webpack_public_path__ + "img/2022-15.acf24fb6.jpg";